import { Injectable } from '@angular/core';
import { ServiceBase } from './service.base';
import { FiliaisApi } from '../api/filiais.api';
import { IFilial } from '../models/filial';
import { IFilialDTO } from '../dto/filial-dto';

@Injectable()
export class FiliaisService extends ServiceBase<IFilial, IFilialDTO> {

  constructor(api: FiliaisApi) {
    super(api);
  }
}
